import React from 'react';
import PropTypes from 'prop-types';
import { toArray } from 'lodash'

var SvgContainer = React.createClass({

  documentWidthRate: 0,
  documentHeightRate: 0,

  propTypes: {
    viewBox: PropTypes.array.isRequired
  },

  childContextTypes: {
    width: PropTypes.number,
    height: PropTypes.number,
    font: PropTypes.string,
    relative: PropTypes.func,
    relativeX: PropTypes.func,
    relativeY: PropTypes.func,
    _define: PropTypes.func,
    _undefine: PropTypes.func,
    linkTo: PropTypes.func,
    getFontSize: PropTypes.func
  },

  getInitialState(){
    return {
      defs: {}
    };
  },

  getChildContext() {
    var self = this;
    var {viewBox} = this.props;

    return {
      width: viewBox[2] - viewBox[0],
      height: viewBox[3] - viewBox[1],
      font: "Arial",
      relative(parent, child){
        return parent / 100 * child;
      },
      relativeX(x) {
        return this.relative(this.width, x);
      },
      relativeY(y) {
        return this.relative(this.height, y);
      },
      _define(key, element, override){
        if (self.state.defs.hasOwnProperty(key) && !override) {
          return;
        }
        var defs = self.state.defs;
        defs[key] = element;
        self.setState({defs: defs});
      },
      _undefine(key){
        var defs = self.state.defs;
        defs[key] = null;
        self.setState({defs: defs});
      },
      linkTo(id){
        return id
          ? "url(#{0})".format([id])
          : ""
      },

      getFontSize(baseSize){
        return baseSize;

        return self.documentHeightRate > 0 && self.documentHeightRate < 1
          ? baseSize * self.documentHeightRate
          : baseSize;
      }
    };
  },

  componentDidMount(){
    var container = this.refs['SvgContainer'],
      rect = (container) ? container.getBoundingClientRect() : {
        width: 0,
        height: 0
      };

    var {viewBox} = this.props;

    this.documentWidthRate = (viewBox[2] - viewBox[0]) / rect.width;
    this.documentHeightRate = (viewBox[3] - viewBox[1]) / rect.height;
  },

  render(){
    return (
      <svg {...this.props}
           xmlnsXlink="http://www.w3.org/1999/xlink"
           xmlns="http://www.w3.org/2000/svg"
           viewBox={this._getViewBox()} version="1.1"
           ref="SvgContainer"
           style={{ direction: 'ltr' }}
      >
        <defs>
          {toArray(this.state.defs)}
        </defs>
        {this.props.children}
      </svg>
    );
  },

  _getViewBox(){
    return this.props.viewBox.join(" ");
  }

});

module.exports = SvgContainer;
